import { toast } from "react-toastify";
import { observable } from "mobx";
import { api_adm } from "../../api";
import { INotaVar } from "../../model";

class _NotaVarFcpStore {
  obs = observable({
    vars_fcp: [] as INotaVar[]
  })

  async load() {
    try {
      let resp = await api_adm.get("/api/admin/nota_vars/fcp/index")

      this.obs.vars_fcp = [];
      this.obs.vars_fcp = resp.data
    } catch { }
  }

  handleRefresh() {
    window.location.reload();
  }

  async get(id: string) {
    let resp = await api_adm.get(`/api/admin/nota_vars/fcp/show/${id}`);
    return resp.data;
  }

  async handleSave(notaVarFcp) {
    let resp;

    if (notaVarFcp._id) {
      let params = {
        _id: notaVarFcp._id,
        nome: notaVarFcp.nome,
        campo: notaVarFcp.campo,
        descricao: notaVarFcp.descricao,
      }
      resp = await api_adm.post(`/api/admin/nota_vars/fcp/update`, params);
    } else {
      let params = {
        nome: notaVarFcp.nome,
        campo: notaVarFcp.campo,
        descricao: notaVarFcp.descricao,
      }
      resp = await api_adm.post("/api/admin/nota_vars/fcp/create", params);
    }

    if (resp.data.ok) {
      toast.success(`Variável salva com sucesso`, {});
      NotaVarFcpStore.load();
    } else {
      toast.error('Erro salvando variável', {});
    }
  }

  async handleDelete(id: string) {

    try {
      let resp = await api_adm.delete(`/api/admin/nota_vars/fcp/delete/${id}`);
      if (resp.data.ok) {
        toast.success(`Variável excluída`, {});
        NotaVarFcpStore.load();
      } else {
        toast.error('Erro excluindo variável', {});
      }
    } catch (ex) {
      toast.error('Erro excluindo variável', {});
    }
  }
}

export const NotaVarFcpStore = new _NotaVarFcpStore();
